import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import PropTypes from 'prop-types';
//import './ProcessingLevelInfoStyles.css';

const getNovaColor = (classification) => {
    const level = classification.match(/\d/);
    switch (level?.[0]) {
        case '1':
            return 'success';
        case '2':
            return 'info';
        case '3':
            return 'warning';
        case '4':
            return 'danger';
        default:
            return 'secondary';
    }
};

const ProcessingLevelInfo = ({ processing }) => {
    if (!processing) return null;

    const badgeColor = getNovaColor(processing.classification);

    return (
        <Card className="processing-card shadow-sm mb-4">
            <Card.Header className="processing-header">
                <h4 className="mb-0">
                    <span className="processing-icon">🧬</span> Processing Level
                </h4>
            </Card.Header>
            <Card.Body>
                <h5 className="mb-3">
                    <Badge bg={badgeColor} className="nova-badge">
                        {processing.classification}
                    </Badge>
                </h5>
                <p className="text-muted">{processing.description}</p>
            </Card.Body>
        </Card>
    );
};

ProcessingLevelInfo.propTypes = {
    processing: PropTypes.shape({
        classification: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired
    })
};

export default ProcessingLevelInfo;
